/* ============================================================
   HELLA GOOD CUP — Theme JS v5
   Handles: mobile menu, cart drawer, email popup, search,
   filter tabs, scroll arrows, grind selectors, newsletter
   ============================================================ */

(function () {
  'use strict';

  // ── Utility ──────────────────────────────────────────────
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  // ── Mobile Menu ───────────────────────────────────────────
  // header.liquid uses: #mobile-menu-open, #mobile-menu-close, #mobile-nav-overlay
  var mobileMenuBtn = $('#mobile-menu-open');
  var mobileNav     = $('#mobile-nav');
  var mobileOverlay = $('#mobile-nav-overlay');
  var mobileClose   = $('#mobile-menu-close');

  function openMobileMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  on(mobileMenuBtn, 'click', openMobileMenu);
  on(mobileClose, 'click', closeMobileMenu);
  on(mobileOverlay, 'click', closeMobileMenu);

  // ── Cart Drawer ───────────────────────────────────────────
  // header.liquid uses: #cart-toggle; cart-drawer.liquid uses: #cart-close
  var cartDrawer  = $('#cart-drawer');
  var cartOverlay = $('#cart-overlay');
  var cartClose   = $('#cart-close');
  var cartToggle  = $('#cart-toggle');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  on(cartToggle,  'click', openCart);
  on(cartClose,   'click', closeCart);
  on(cartOverlay, 'click', closeCart);

  // Also support data-open-cart buttons anywhere on page
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-open-cart]')) { openCart(); }
  });

  // Cart count badge — header uses #cart-count
  function updateCartCount(count) {
    var countEl = $('#cart-count');
    if (countEl) {
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  // Refresh cart from Shopify AJAX API
  function refreshCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        renderCartItems(cart);
        updateShippingBar(cart.total_price);
      })
      .catch(function(e) { console.warn('Cart fetch failed', e); });
  }

  function updateShippingBar(totalCents) {
    var threshold = 4900; // $49 free shipping
    var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
    var fill = $('#cart-shipping-fill');
    var msg  = $('#cart-shipping-msg');
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (totalCents >= threshold) {
        msg.textContent = '🎉 You qualify for FREE shipping!';
      } else {
        var remaining = ((threshold - totalCents) / 100).toFixed(2);
        msg.textContent = 'Add $' + remaining + ' more for FREE shipping';
      }
    }
  }

  function renderCartItems(cart) {
    var container = $('#cart-items');
    var emptyEl   = $('#cart-empty');
    var footerEl  = $('#cart-footer');
    if (!container) return;

    if (cart.item_count === 0) {
      container.innerHTML = '';
      if (emptyEl)  emptyEl.style.display  = 'flex';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (emptyEl)  emptyEl.style.display  = 'none';
    if (footerEl) footerEl.style.display = 'block';

    container.innerHTML = cart.items.map(function(item) {
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<img class="cart-item-img" src="' + item.image + '" alt="' + item.title + '" />' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-name">' + item.product_title + '</div>' +
          '<div class="cart-item-roast">' + (item.variant_title || '') + '</div>' +
          '<div class="cart-item-qty">' +
            '<button class="cart-qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
            '<span class="cart-qty-num">' + item.quantity + '</span>' +
            '<button class="cart-qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-item-price">$' + (item.line_price / 100).toFixed(2) + '</div>' +
      '</div>';
    }).join('');

    // Subtotal
    var subtotalEl = $('#cart-subtotal-amount');
    if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);

    // Qty buttons
    $$('.cart-qty-btn', container).forEach(function(btn) {
      on(btn, 'click', function() {
        var key = btn.dataset.key;
        var qty = parseInt(btn.dataset.qty, 10);
        updateCartItem(key, qty);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      renderCartItems(cart);
      updateShippingBar(cart.total_price);
    });
  }

  // Add to cart
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    var qty = parseInt(btn.dataset.qty || '1', 10);
    if (!variantId) return;

    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = 'Added!';
      setTimeout(function() {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 1500);
      refreshCart();
      openCart();
    })
    .catch(function() {
      btn.textContent = 'Error';
      btn.disabled = false;
    });
  });

  // ── Email Popup ───────────────────────────────────────────
  // email-popup.liquid uses: #email-popup-overlay, #email-popup, #email-popup-close
  var popupOverlay = $('#email-popup-overlay');
  var emailPopup   = $('#email-popup');
  var popupClose   = $('#email-popup-close');
  var popupForm    = $('#popup-form');
  var popupSuccess = $('#popup-success');

  function showPopup() {
    if (!emailPopup) return;
    if (localStorage.getItem('hgc_popup_shown')) return;
    emailPopup.style.display = 'block';
    if (popupOverlay) popupOverlay.style.display = 'block';
  }
  function hidePopup() {
    if (!emailPopup) return;
    emailPopup.style.display = 'none';
    if (popupOverlay) popupOverlay.style.display = 'none';
    localStorage.setItem('hgc_popup_shown', '1');
  }

  on(popupClose, 'click', hidePopup);
  on(popupOverlay, 'click', hidePopup);

  if (popupForm) {
    on(popupForm, 'submit', function(e) {
      e.preventDefault();
      var email = popupForm.querySelector('input[type="email"]').value;
      if (!email) return;
      popupForm.style.display = 'none';
      if (popupSuccess) popupSuccess.style.display = 'block';
      localStorage.setItem('hgc_popup_shown', '1');
      setTimeout(hidePopup, 4000);
    });
  }

  // Show popup after 6 seconds
  setTimeout(showPopup, 6000);

  // ── Search Bar ────────────────────────────────────────────
  var searchToggle = $('#search-toggle');
  var searchBar    = $('#search-bar');
  var searchClose  = $('#search-close');
  var searchInput  = $('#search-input');

  on(searchToggle, 'click', function() {
    if (!searchBar) return;
    var isOpen = searchBar.style.display === 'block';
    searchBar.style.display = isOpen ? 'none' : 'block';
    if (!isOpen && searchInput) searchInput.focus();
  });
  on(searchClose, 'click', function() {
    if (searchBar) searchBar.style.display = 'none';
  });

  // ── Filter Tabs (Featured Products) ──────────────────────
  $$('.filter-tab, .filter-tab-mobile').forEach(function(tab) {
    on(tab, 'click', function() {
      var filter = tab.dataset.filter;
      // Deactivate all tabs
      $$('.filter-tab, .filter-tab-mobile').forEach(function(t) {
        t.classList.remove('active');
      });
      // Activate clicked tabs (both desktop + mobile)
      $$('[data-filter="' + filter + '"]').forEach(function(t) {
        t.classList.add('active');
      });
      // Show/hide product cards (data-filter may contain multiple space-separated values)
      $$('.product-card').forEach(function(card) {
        var cardFilters = (card.dataset.filter || 'all').split(' ');
        var show = filter === 'All' || filter === 'all' || cardFilters.indexOf(filter) !== -1;
        card.style.display = show ? '' : 'none';
      });
    });
  });

  // ── Scroll Arrows (Product Row + Bundles Carousel) ──────────
  $$('.scroll-arrow').forEach(function(arrow) {
    on(arrow, 'click', function() {
      // Find the closest scroll container (products or bundles)
      var wrap = arrow.closest('.products-scroll-wrap') || arrow.closest('.bundles-carousel-wrap');
      if (!wrap) return;
      var row = wrap.querySelector('.products-scroll-row') || wrap.querySelector('.bundles-grid');
      if (!row) return;
      var dir = arrow.classList.contains('scroll-arrow-left') ? -1 : 1;
      // Use actual card width for accurate scrolling
      var card = row.querySelector('.product-card') || row.querySelector('.bundle-card');
      var cardWidth = card ? card.offsetWidth + 20 : 300;
      row.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
    });
  });

  // ── Grind Selectors ───────────────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.grind-btn');
    if (!btn) return;
    var group = btn.closest('.grind-selector, .bundle-grind');
    if (!group) return;
    $$('.grind-btn', group).forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
  });

  // ── Newsletter Form → Mautic Form 5 ──────────────────────
  var newsletterForm    = $('#newsletter-form');
  var newsletterSuccess = $('#newsletter-success');

  if (newsletterForm) {
    on(newsletterForm, 'submit', function(e) {
      e.preventDefault();
      var email = newsletterForm.querySelector('#newsletter-email').value;
      if (!email) return;
      
      // Submit to Mautic Form 5 (Newsletter Signup)
      var formData = new FormData();
      formData.append('mauticform[formId]', '5');
      formData.append('mauticform[email]', email);
      formData.append('mauticform[messenger]', '1');
      
      fetch('https://mautic.brewsandteas.com/form/submit', {
        method: 'POST',
        body: formData,
        mode: 'no-cors'
      }).then(function() {
        newsletterForm.style.display = 'none';
        if (newsletterSuccess) newsletterSuccess.style.display = 'flex';
      }).catch(function() {
        newsletterForm.style.display = 'none';
        if (newsletterSuccess) newsletterSuccess.style.display = 'flex';
      });
    });
  }

  // ── Quiz Card (Hero) ──────────────────────────────────────
  $$('.quiz-card-option').forEach(function(opt) {
    on(opt, 'click', function() {
      window.location.href = '/pages/coffee-quiz';
    });
  });

  // ── Initial cart count ────────────────────────────────────
  refreshCart();

})();
